import initializeMobileMenu from './menu';
import initializeFiles from './blocks/files';
import initializeFancyBox from './fancybox';
import initializeFancyboxWP from './fancyboxwp';
import initializeForm from './utils/form';
import initializeLazyYoutube from "./utils/lazy-youtube";
import initializeHeader from "./utils/header";
import blockLogotypes from './blocks/logotypes';
// import initializeBoxSlider from "./blocks/box-slider";
// import initializeSidebarCategories from "./blocks/woo-sidebar-categories";

// import initializeAccordions from "./blocks/accordion";
// import initializeIconBoxes from './blocks/icon-boxes';
// import initializeNumbersBlock from './blocks/numbers';
// import initializeGallerySection from './blocks/gallery-section';
import initializeGalleryGrid from "./blocks/gallery-grid";
// import initializeBrands from './blocks/brands';
// import initializeGallerySlider from './blocks/gallery-slider';
// import initializeGalleryText from './blocks/gallery-text';
// import initializeIconBoxesAnimation from './blocks/icon-boxes-animation';
// import WooCommerce from './woo'

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        import('aos/dist/aos.js').then(({ default: AOS }) => {
            AOS.init({
                startEvent: 'load',
                disable: 'mobile',
                once: true,
                duration: 1000
            });
        });
        initializeHeader();
        initializeForm();
        initializeFancyBox()
        initializeMobileMenu();
        initializeFiles();
        initializeLazyYoutube();
        blockLogotypes();
        initializeFancyboxWP();
        // initializeBoxSlider();
        // initializeSidebarCategories();

        // initializeAccordions();
        // initializeCollapse();
        // initializeIconBoxes();
        // initializeNumbersBlock();
        // initializeGallerySection();
        initializeGalleryGrid();
        // initializeBrands();
        // initializeGallerySlider();
        // initializeGalleryText();
        // initializeIconBoxesAnimation();

        // const Woo = new WooCommerce();
    }
}

function initializeApp() {
    const app = new App();

}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}